/**
 * Landing pages: smooth scroll to a section on the same page.
 *
 * Live's theme script smooth-scrolls every in-page #anchor click; a plain anchor jumps. One delegated listener
 * covers the page's call-to-action links that point at an id on the page (landing buttons, the hero and feature
 * steps buttons), the landing announcement bar's offer link and the landing header's button (Vesper's "Drink
 * Vesper"). Tab and control links, modified clicks, missing targets and visitors who prefer reduced motion
 * keep the browser's own jump.
 */
if (!window.__landingButtonSmoothScroll) {
  window.__landingButtonSmoothScroll = true;

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    const link = event.target.closest(
      ':is(main, .landing-announcement, landing-header) a[href^="#"]:not([role]):not([aria-controls]):not([data-no-smooth])'
    );
    if (!link || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const id = link.getAttribute('href').slice(1);
    const target = id ? document.getElementById(decodeURIComponent(id)) : null;
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
}
